import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';

// services
import {ConfigManager} from '../../services/ConfigManager';

// styles
import {FooterWrapper} from './Footer-styles';
import {LinkSecondary} from '../../styles';

const Footer = () => {
  const {t} = useTranslation();
  const portalConfig = ConfigManager.getConfig();

  return (
    <FooterWrapper>
      <LinkSecondary href={portalConfig?.termAndConditionsUrl}>
        {t('footer_termsAndConditions')}
      </LinkSecondary>
      <LinkSecondary href={portalConfig?.privacyPolicyUrl}>
        {t('footer_privacyPolicy')}
      </LinkSecondary>
    </FooterWrapper>
  );
};

export default Footer;
